
import { post } from '../utils/http';

export function userResetPassword(param) {
    return post('v1/admin/user/email/resetpassword', param);
}